import Source, {SourceData} from "./source";

/**
 *
 * @param products
 * @returns {JSX.Element}
 * @constructor
 */
export default function SourceList ( { sources, align } : { sources: SourceData[], align : string } ) {
    //pt-2 font-weight-lighter small fst-italic text-muted

    // render
    return (
        <>
            <ul className={('start' === align ? "" : "text-center ") + "pt-1"}>
            {sources.map((source, index) =>
                <li key={index}>
                    <Source
                        description={source.description}
                        url={source.url}
                        name={source.name}
                        licence={source.licence}
                    />
                </li>
            )}
            </ul>
        </>
    );
}